export enum InputStateEnum {
  Default = 'default',
  Error = 'error',
  Success = 'success',
  Disabled = 'disabled',
}

export type InputStateType = keyof typeof InputStateEnum;
